import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Dialog } from '../../molecules'

import { mediaPc } from '../../../lib/MediaQuery'

type Props = {
  title?: string
  children?: React.ReactNode
  displayCancel?: boolean
  onClickCancel?: () => void
  onClickOk?: () => void
}

const Wrapper = styled.div`
  display: block;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
  display: flex;
  justify-content: center;
  align-items: center;

  ${mediaPc`
    align-items: start;
  `}
`

export const DialogTpl: React.FC<Props> = ({ title, children, displayCancel, onClickCancel, onClickOk }) => {
  useEffect(() => {
    document.body.style.top = `-${window.scrollY}px`
    document.body.style.position = 'fixed'

    return () => {
      const scrollY = document.body.style.top
      document.body.style.position = ''
      document.body.style.top = ''
      window.scrollTo(0, parseInt(scrollY || '0') * -1)
    }
  })

  return (
    <Wrapper>
      <Dialog title={title} displayCancel={displayCancel} onClickCancel={onClickCancel} onClickOk={onClickOk}>
        {children}
      </Dialog>
    </Wrapper>
  )
}
